import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateFtlApplicationInputModel } from "./components/FtlForm";
import { CreateFclApplicationInputModel } from "./components/FclForm";

const initialState: {
  open: boolean;
  loading: boolean;
  leadId?: number;
} = {
  open: false,
  loading: false,
};

const createApplicationModalSlice = createSlice({
  name: "createApplicationModal",
  initialState,
  reducers: {
    openModal(state, action: PayloadAction<number | undefined>) {
      state.open = true;
      state.leadId = action.payload;
    },
    closeModal(state) {
      state.open = false;
      state.leadId = undefined;
    },
    createFtlApplication(state, _action: PayloadAction<CreateFtlApplicationInputModel>) {
      state.loading = true;
    },
    createFclApplication(state, _action: PayloadAction<CreateFclApplicationInputModel>) {
      state.loading = true;
    },
    createApplication(
      state,
      _action: PayloadAction<{
        transportCharacteristicId: number;
        currencyId: number;
        companyId: number;
      }>,
    ) {
      state.loading = true;
    },
    createApplicationSuccess(state) {
      state.open = false;
      state.loading = false;
    },
    createApplicationReject(state) {
      state.loading = false;
    },
  },
});

export default createApplicationModalSlice;
